export default "__VITE_ASSET__98e6f5f5__"